import { backendRequest } from "../../../stores/thunks";
import store from "../../../stores/store";

export default async function saving(workflow) {

    workflow.title = workflow.flowData.nodes[0].data.title
    workflow.text = workflow.flowData.nodes[0].data.description

    console.log('SAVE', workflow)

    try {
        const response = await store.dispatch(backendRequest('STUDIO_AUTOSAVE', '/studio/workflow/' + workflow.id, {
            name: workflow.title,
            description: workflow.text,
            workflowData: JSON.stringify(workflow)
        }, 'PUT', false))
        console.log('AUTOSAVE', response)

        let settings = store.getState().settings
        if (settings.changed.includes(workflow.id)) {
            store.dispatch(backendRequest('SETTINGS', '/user', { settings: JSON.stringify({ ...settings, changed: settings.changed.filter(id => id != workflow.id) }) }, 'PUT', false))
        }

        return response
    } catch (error) {
        console.log('AUTOSAVE: Error', error)
        return error
    }
}